/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// import React from 'react';
import { useQuery, gql } from '@apollo/client';

export default (domain, env) => {
    const CATEGORY_DATA_QUERY = gql`{findContent(brand: "${domain}", environment: "${env}", contentType: "recipe_category_list"){ content }}`;
    const { error, data } = useQuery(CATEGORY_DATA_QUERY);
    if (error) return null;
    const categoryData = data?.findContent?.content?.entries?.[0]?.group;
    if (!data?.findContent?.content?.entries) return null;
    const categories = [];
    categoryData.map((cat) => {
        const category = {
            name: cat.category_name,
            link: cat.category_url,
        };
        categories.push(category);
        return null;
    });
    return categories;
};
